<div class="close-button" (click)="closeDialog()">
	<div class="cross">
		<div class="line-v"></div>
		<div class="line-h"></div>
	</div>
</div>
<dodo-info-dialog-layout (close)="closeDialog()" source="mobile" [class.rounded-corner]="isNewSimkit">
		<div class="header" header>
		@if(!isNewSimkit){
			<div class="flex flex-row flex-align-items-end mt3"  *ngIf="icon || subtitle">
				<div class="mr2" *ngIf="icon">
					<img class="icon" src="{{icon }}" alt="icon" />
				</div>
				<div class="subtitle" *ngIf="subtitle"  [innerHTML]="subtitle"></div>
			</div>
		}
		<div class="title">{{ title }}</div>
	</div>
	<div class="popup-content" content>
		
		<div class="heading" [innerHTML]="message"></div>
		<div class="info">
			<p></p>
		</div>
		<div class="actions">
			@if (secondButtonLink) {
				<dodo-raised-button
					(clicked)="closeDialog()"
					[color]="'white'"
					[height]="48"
				>
					CLOSE
				</dodo-raised-button>
				<dodo-raised-button
					(clicked)="secondButtonClicked()"
					[color]="'primary'"
					[height]="48"
				>
					VIEW PLANS
				</dodo-raised-button>
			} @else {			
				@if(isNewSimkit){
					<secondary-button class="action-btn" color="secondary" (clicked)="closeDialog()"
						[height]="50" 
						[theme]="buttonTheme">
						{{ buttonText }}
					</secondary-button>
				} @else{
					<dodo-raised-button 
						(clicked)="closeDialog()"
						[color]="buttonColor"
						[height]="48"
					>
						{{ buttonText }}
					</dodo-raised-button>
				}
			}
		</div>
	</div>
</dodo-info-dialog-layout>
